import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { LARGE_MARGIN, MIDDLE_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerWrapper: {
      '& $title': {
        textAlign: 'left',
      },
    },
    title: {},
    container: {
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: LARGE_MARGIN,
      },
    },
    link: {
      color: 'inherit',
    },
    tabsRoot: {
      marginBottom: MIDDLE_MARGIN,
    },
    card: {
      borderRadius: 10,
      padding: 24,
      background: theme.palette.secondary.light,
      [theme.breakpoints.up('md')]: {
        padding: 32,
      },
    },
    selectWrapper: {
      background: theme.palette.secondary.light,
      borderRadius: 50,
      padding: '5px 15px',
      maxWidth: 500,
      width: '100%',
      position: 'relative',
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('sm')]: {
        maxWidth: 'unset',
        display: 'inline-flex',
        width: 'unset',
      },
    },
    select: {
      width: '100%',
    },
    selectButtonBase: {
      width: '100%',
    },
    selectHeader: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
    },
  }),
);

export default useStyles;
